import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Boeing737-800NG.png'


const _withScopeId = n => (_pushScopeId("data-v-83f0a1b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "background",
  src: _imports_0
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "notification"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Disclaimer", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Verification email may go into the "),
  /*#__PURE__*/_createElementVNode("strong", null, "spam"),
  /*#__PURE__*/_createTextVNode(" folder.")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Sender:"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("u", null, "Augmented Knowledge <augmentedk@daum.net>")
], -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "buttons"
}

import { ref } from "vue";
import { onMounted } from "vue";
import { api } from "@/service/api";
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerifyPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const redirectFrom = ref<string>(route.query.redirectFrom?.toString() || "/");

const state = ref<string>("In progress");

const resendEmailVerification = async () => {
  await api.post("/resend-verification-email");
  alert("Verification email has been sent.");
  router.push("/");
}

onMounted(async () => {
  const result = await api.get("/profile", {
    params: {
      q: String(new Date().getTime())
    }
  });

  if (result.status === 200) {
    state.value = "Success";
    router.push("/");
  } else {
    state.value = "Failed";
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", null, [
      _createTextVNode("Email Verification "),
      _createElementVNode("span", null, _toDisplayString(state.value), 1)
    ]),
    (state.value !== 'Success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
      : _createCommentVNode("", true),
    (state.value !== 'Success')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn btn-green",
            onClick: resendEmailVerification
          }, "Resend Email verification")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})